module.exports = "https://www.niulinkcloud.com/_next/static/media/icon2.cdfc3150290d4d0dc94d151312e04181.png";